// Throttle function to limit the rate at which a function can be called
// This is useful for performance optimization, especially when dealing with events that can fire rapidly, like scroll or resize events.
export default function throttle(func, limit) {
    let inThrottle;
    return function (...args) {
        if (!inThrottle) {
            func.apply(this, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
        }
    };
}
// Usage example:
// const onScroll = throttle(() => {
//     console.log('Scroll event:', window.scrollY);
//     // Your scroll handling logic here
// }, 100); // Adjust throttle time (ms) as needed
// window.addEventListener('scroll', onScroll);
//
// This will ensure that the scroll event is not triggered more than once every 100 miliseconds.
//
